import { MapPin, User, Pencil, Trash2 } from "lucide-react";

export default function SavedAddressCard({ address, onChange, onForget }) {
  const line = [address.building, `Door ${address.door_number}`, address.floor ? `Floor ${address.floor}` : ""].filter(Boolean).join(", ");
  return (
    <section data-testid="saved-address-card" className="bg-white rounded-2xl border-2 border-[#FF6600]/40 p-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display font-bold text-gray-900">Deliver to your saved address</h2>
        <button type="button" onClick={onChange} data-testid="saved-address-change" className="text-sm font-semibold text-[#CC1A00] flex items-center gap-1">
          <Pencil size={13} /> Change
        </button>
      </div>
      <div className="space-y-1.5 text-sm">
        <div className="flex items-center gap-2 text-gray-700"><User size={14} className="text-gray-400" /> {address.customer_name} · {address.phone}{address.email ? ` · ${address.email}` : ""}</div>
        <div className="flex items-start gap-2 text-gray-700" data-testid="saved-address-line">
          <MapPin size={14} className="text-[#CC1A00] mt-0.5" /> <span>{line} (pinned on map)</span>
        </div>
      </div>
      <button type="button" onClick={onForget} data-testid="saved-address-forget" className="mt-3 text-xs text-gray-500 hover:text-red-600 flex items-center gap-1">
        <Trash2 size={12} /> Forget this address
      </button>
    </section>
  );
}
